import React from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { Remove as RemoveIcon, Check as CheckIcon, Build as BuildIcon, FiberManualRecord as CircleIcon } from '@mui/icons-material';

const FONT_SIZE = 14;

const statuses = [
    {
        label: 'תהליך שעוד לא התחיל',
        icon: <RemoveIcon />,
        bgColor: '#AFBDD3',     // grey 400
        iconColor: '#FFFFFF',   // grey 600
    },
    {
        label: 'תהליך שהסתיים',
        icon: <CheckIcon />,
        bgColor: '#77DBA4',     // green 500
        iconColor: '#ffffff',
    },
    {
        label: 'תהליך בביצוע',
        icon: <BuildIcon />,
        bgColor: '#1293FE',     // blue 500
        iconColor: '#ffffff',
    },
    {
        label: 'עיכוב של עד שנה',
        bgColor: '#FFBD06',     // amber 500
        iconColor: '#212121',   // grey 900
    },
    {
        label: 'עיכוב של מעל שנה',
        bgColor: '#ff5722',     // deepOrange 500
        iconColor: '#ffffff',
    },
];

export default function VerticalLegendComponent() {
    return (
        <Box>
            <List disablePadding>
                {statuses.map((item, idx) => (
                    <ListItem key={idx} sx={{ py: 0.5, mb: idx === 2 ? 2 : 0 }}>
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            <Box
                                sx={{
                                    width: FONT_SIZE + 8,
                                    height: FONT_SIZE + 8,
                                    borderRadius: '50%',
                                    bgcolor: item.bgColor,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {item.icon && React.cloneElement(item.icon, {
                                    sx: { fontSize: FONT_SIZE, color: item.iconColor },
                                })}
                            </Box>
                        </ListItemIcon>
                        <ListItemText
                            sx={{ textAlign: 'right' }}
                            primary={
                                <Typography
                                    sx={{
                                        fontSize: FONT_SIZE,
                                        lineHeight: 1.2,
                                        color: '#0C3768',
                                        fontWeight: 700,
                                        textAlign: 'right',
                                    }}
                                >
                                    {item.label}
                                </Typography>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}
